import React from "react";
import styled from "styled-components";

const SpinnerSpan = styled.span`
    display: block;
    position: relative;
    margin: 0 auto;
    width: 35px;
    &.inline-after {
        display: inline-block;
        margin-left: 2em;
        vertical-align: middle;
    }
    &:before {
        content: "";
        display: block;
        padding-top: 100%;
    }

    svg {
        animation: spinner-rotate 2s linear infinite;
        height: 100%;
        transform-origin: center center;
        width: 100%;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
    }

    circle {
        stroke-dasharray: 1, 200;
        stroke-dashoffset: 0;
        animation: spinner-dash 1.5s ease-in-out infinite;
        stroke: #333366;
        stroke-width: 6px;
        stroke-linecap: round;
    }

    @keyframes spinner-rotate {
        100% {
            transform: rotate(360deg);
        }
    }

    @keyframes spinner-dash {
        0% {
            stroke-dasharray: 1, 200;
            stroke-dashoffset: 0;
        }
        50% {
            stroke-dasharray: 89, 200;
            stroke-dashoffset: -35px;
        }
        100% {
            stroke-dasharray: 89, 200;
            stroke-dashoffset: -124px;
        }
    }
`;

export const Spinner = (props) => {
    return (
        <SpinnerSpan {...props}>
            <svg viewBox="25 25 50 50">
                <circle
                    cx="50"
                    cy="50"
                    r="20"
                    fill="none"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                />
            </svg>
        </SpinnerSpan>
    );
};
